import './PetListDetails.scss';
import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as PetCat } from '@/assets/img/pet-cat-default-icon.svg';
import { ReactComponent as PetDog } from '@/assets/img/pet-dog-default-icon.svg';
import { Pets } from '@/features/customers';
import Utils from '@/utils/util';
type PetConfirmationDisplayProps = {
  data?: Pets;
  showPrice: boolean;
  currency?: any;
};
export const PetConfirmationDisplay = ({
  data,
  showPrice,
  currency,
}: PetConfirmationDisplayProps) => {
  return (
    <div className={`pet-display`}>
      <div className="left-section">
        <div className="pets-image">
          {data && data.petsImageUrl ? (
            <img src={data.petsImageUrl} />
          ) : data?.petType?.toLowerCase() === 'dog' ? (
            <PetDog />
          ) : (
            <PetCat />
          )}
        </div>
        <div className="details">
          <div className="name" title={data?.name}>
            {data?.name}
          </div>
          <span className="seperator"></span>
          <div className="breed" title={data?.breed}>
            {data?.breed}
          </div>
        </div>
      </div>
      {showPrice && (
        <div className="right-section">
          <span className="amount">
            +{currency ? currency : '$'}
            {Utils.formatAmount(data?.fee)}
          </span>
        </div>
      )}
    </div>
  );
};
